module.exports = __webpack_public_path__ + "media/images/pc/banner/hokepon-78bb3784d62963797b5d8894af15eed2.png";